export default __webpack_public_path__ + "static/media/404.4f528983.png";